<template>
  <section>
    <header>
      <SocieteSelector/>
      <p class="is-size-6 has-text-grid-1 has-text-weight-bold pb-20">
        {{ labeltrad.title }}
      </p>
    </header>
    <MsgError
      v-if="messagesErrors.length"
      type="is-danger"
      :msgs="messagesErrors"
      @close="$emit('msgErrorClose')"/>
    <section class="mb-10">
      <div class="level">
        <div class="level-left">
          <upload-image
            v-model="tiers.srcImg"
            :height-img="tiers.heightImg"
            :type="tiers.typologie"
            @fileChange="$emit('setLogo', $event)"
            @dataUrlIcon="tiers.icon = $event"
            @heightImgChange="tiers.heightImg = $event"
            @error="messagesErrors.push($event || $t('general.msgErrorDropdown'))"/>
        </div>
        <div class="level-item is-width-100p-148px pl-10">
          <div class="column columns is-multiline is-marginless is-paddingless">
            <div class="column is-paddingless is-12 mb-10">
              <b-field class="pl-10" :type="errors.nomCommercial ? 'is-danger' : ''">
                <template slot="label">
                  <qd-label :label="labeltrad.libelle" required />
                </template>
                <b-input v-model.trim="tiers.nomCommercial"></b-input>
              </b-field>
            </div>
            <div class="column is-paddingless is-12">
              <b-field class="pl-10" :type="errors.adresseError ? 'is-danger' : ''">
                <template slot="label">
                  <qd-label :label="labeltrad.labelAdresse" required />
                </template>
                <AutoCompleteAdresse
                  @place_change="adresseChange"
                  @error="messagesErrors.push($event)"
                  :libelle="libelleAdresse"
                  :is-error="errors.adresseError"/>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </section>
    <qd-adresse
      :adresse="tiers.adressePostale"
      :error="errors.adressePostale"
      :minimumField="!isModif"
      :coordonneesRequired="isTiersPdv"
      class="mb-10"/>
    <section class="columns is-multiline mb-10">
      <div v-if="!minimumField" class="column is-6">
        <b-field
          :label="$t('creerClient.labelChamp.telephone')"
          custom-class="is-size-7 has-text-grid-2">
          <b-input v-model="tiers.telephone"></b-input>
        </b-field>
      </div>
      <div v-if="!minimumField" class="column is-6">
        <b-field
          :label="$t('creerClient.labelChamp.email')"
          custom-class="is-size-7 has-text-grid-2">
          <b-input v-model="tiers.email"></b-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field :type="errors.siren ? 'is-danger' : ''">
          <template slot="label">
            <qd-label
              :label="$t('creerClient.labelChamp.siren')"
              :required="!tiers.prospect" />
          </template>
          <b-input v-model="tiers.siren"></b-input>
        </b-field>
      </div>
      <div v-if="!estConcurrent" class="column is-6">
        <b-field
          :label="$t('creerClient.labelChamp.referenceHavas')"
          custom-class="is-size-7 has-text-grid-2">
          <b-input v-model.trim="tiers.referenceHavas"></b-input>
        </b-field>
      </div>
      <div v-if="!isTiersGroupe" class="column is-6">
        <b-field :type="errors.tiersParent ? 'is-danger' : ''">
          <template slot="label">
            <qd-label
              :label="labeltrad.libelleTiersParent"
              :required="isTiersPdv" />
          </template>
          <b-autocomplete
            v-model="searchTiersParent"
            :data="filteredDataParent"
            :loading="listParentIsLoad"
            @select="selectParent"
            clearable
            open-on-focus
            field="nomCommercial">
          </b-autocomplete>
        </b-field>
      </div>
      <div class="column is-6">
        <query-marque-tag-input
          v-model="tiers.tiersMarques"
          :label="$t('creerPointDeVente.labelChamp.marque')" />
      </div>
      <div class="column is-6">
        <parametre-autocomplete
          v-model="tiers.secteurActiviteId"
          :target="constantes.PARAMETRES_KEYS.secteurActivite"
          :create="false"
          :label="$t('creerPointDeVente.labelChamp.secteurActivite')"
          class="autocomplete-with-addons"
        />
      </div>
    </section>
  </section>
</template>

<script>
import get from 'lodash/get';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import LISTE_APPLICATION_TVA from '@/configuration/applicationTvaConf';
import * as config from '@/configuration/clientConf';
import { browseClients } from '@/api/clients/index';
import QdLabel from '@/components/general/qdLabel.vue';
import MsgError from '@/components/general/messageErreur';
import QdAdresse from '@/components/general/qdAdresse.vue';
import UploadImage from '@/components/general/uploadImage.vue';
import SocieteSelector from '@/components/general/societeSelector';
import AutoCompleteAdresse from '@/components/general/autoCompleteAdresse.vue';
import QueryMarqueTagInput from '@/components/general/queryMarqueTagInput.vue';
import ParametreAutocomplete from '@/components/general/parametreAutocomplete.vue';
import gestionErreur from '@/services/general/gestionErreur';
import getLogoClient from '@/services/general/getLogoClient';
import adresseGenerer from '@/services/general/genererAdresse';
import { adressFullStringGetter } from '@/services/general/general';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    tiers: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Object,
      required: true,
    },
    messagesErrors: {
      type: Array,
      required: true,
    },
    minimumField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    QdLabel,
    MsgError,
    QdAdresse,
    UploadImage,
    SocieteSelector,
    QueryMarqueTagInput,
    AutoCompleteAdresse,
    ParametreAutocomplete,
  },
  data () {
    return {
      searchTiersParent: '',
      listParentIsLoad: false,
      listeParent: [],
      listeApplicationTva: LISTE_APPLICATION_TVA,
      constantes: { PARAMETRES_KEYS },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isModif() {
      return !!this.tiers.id || this.isEdit;
    },
    baseI18n() {
      return this.isModif ? 'modifierClient' : 'creerClient';
    },
    isTiersPdv() {
      return this.tiers.typologie === config.POINT_VENTE;
    },
    isTiersGroupe() {
      return this.tiers.typologie === config.GROUPE;
    },
    estConcurrent() {
      return (this.tiers.sousTypes || []).includes(config.SOUS_TYPE_CONCURRENT);
    },
    labeltrad() {
      let title = this.$t(`${this.baseI18n}.titlePage`);
      let libelle = this.$t('creerClient.labelChamp.libelle');
      let libelleTiersParent = '';
      let labelAdresse = this.$t('creerClient.labelChamp.adresse');
      if (this.tiers.typologie === config.ENSEIGNE) {
        title = this.$t(`${this.baseI18n}.titlePageEnseigne`);
        libelle = this.$t('creerClient.labelChamp.libelleEnseigne');
        libelleTiersParent = this.$t('creerClient.labelChamp.groupe');
      }
      if (this.tiers.typologie === config.POINT_VENTE) {
        title = this.$t(`${this.baseI18n}.titlePagePDV`);
        libelle = this.$t('creerClient.labelChamp.libellePDV');
        labelAdresse = this.$t('creerClient.labelChamp.adressePDV');
        libelleTiersParent = this.$t('creerClient.labelChamp.enseigne');
      }
      return {
        title,
        libelle,
        labelAdresse,
        libelleTiersParent,
      }
    },
    filteredDataParent() {
      return this.listeParent.filter((option) => {
        return String(option.nomCommercial || '')
          .toString()
          .toLowerCase()
          .indexOf(this.searchTiersParent.toLowerCase()) >= 0
      });
    },
    libelleAdresse() {
      return adressFullStringGetter(this.tiers.adressePostale);
    },
  },
  methods: {
    adresseChange(adresse) {
      const adresseValue = adresseGenerer(adresse);
      adresseValue.intitule1 = this.tiers.nomCommercial;
      this.tiers.adressePostale = adresseValue;
      this.$emit('setAdresse', adresseValue);
    },
    async getListeParent() {
      if (this.tiers.typologie === config.GROUPE) return;
      this.listParentIsLoad = true;
      try {
        const query = {
          type: config.TYPE_CLIENT,
          sousType: config.SOUS_TYPE_AUCUN,
          societeId: this.societeActiveId,
        };
        if (this.tiers.typologie === config.ENSEIGNE) query.typologie = config.GROUPE;
        if (this.tiers.typologie === config.POINT_VENTE) query.typologie = config.ENSEIGNE;
        this.listeParent = (await browseClients(config.WITHOUT_LOGO, query)).data;
      } catch (error) {
        gestionErreur('Erreur lors de la récupération des tiers parents', error);
      } finally {
        this.listParentIsLoad = false;
      }
    },
    async selectParent(tiers) {
      if (!tiers) {
        this.tiers.srcImg = null;
        this.tiers.tiersParent = null;
        this.tiers.tiersParentId = null;
        return;
      }
      if (!this.tiers.srcImg) {
        this.tiers.srcImg = (await getLogoClient(tiers)).logo.chemin;
      }
      this.tiers.tiersParent = tiers;
      this.tiers.tiersParentId = tiers.id;
      this.searchTiersParent = tiers.nomCommercial;
      if (tiers.secteurActiviteId && !this.tiers.secteurActiviteId) {
        this.tiers.secteurActiviteId = tiers.secteurActiviteId;
      }
      if (tiers.applicationTva && !this.tiers.applicationTva) {
        this.tiers.applicationTva = tiers.applicationTva;
      }
      if (tiers.tiersMarques.length > 0 && !this.tiers.tiersMarques.length) {
        this.tiers.tiersMarques = tiers.tiersMarques;
      }
    },
  },
  async mounted() {
    await this.getListeParent();
    if (this.tiers.tiersParentId && !this.tiers.tiersParent) {
      this.tiers.tiersParent = this.listeParent.find(t => t.id === this.tiers.tiersParentId);
    }
    this.searchTiersParent = get(this.tiers, 'tiersParent.nomCommercial', '');
  },
};
</script>
